export default "__VITE_ASSET__6_4iK0DP__"